export default __webpack_public_path__ + "static/media/img_19.d383eeba.JPG";